export default __webpack_public_path__ + "static/media/uploader-ascensiaContour-3.b125b4e6.png";